import { render } from "./auth-admin-as-user.vue?vue&type=template&id=68c30f36&ts=true"
import script from "./auth-admin-as-user.vue?vue&type=script&lang=ts"
export * from "./auth-admin-as-user.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__